import { render, staticRenderFns } from "./ProductionHistory.vue?vue&type=template&id=4bcd5334&"
import script from "./ProductionHistory.vue?vue&type=script&lang=js&"
export * from "./ProductionHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProductionHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports